import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import RemovalShipmentsService from "../../Services/http/RemovalShipmentsService";

const getRemovalShipments = async (dispatch, accountId) => {
    dispatch(setIsActiveSpinner(true));
    const response = await RemovalShipmentsService.getRemovalShipments(
      accountId
    );
    dispatch(setIsActiveSpinner(false));
    return response['items'];
};


const updateOrderDetails = async (dispatch, accountId, removalOrderID, orderDetails) => {
  dispatch(setIsActiveSpinner(true));
  const response = await RemovalShipmentsService.updateOrderDetails(
    accountId, removalOrderID, orderDetails
  );
  dispatch(setIsActiveSpinner(false));
  if (response && response['message'] === 'success') {
    getRemovalShipments(dispatch, accountId);
  } else {
    alert('error in update order details');
  }
};


const RemovalShipmentUtils = {
    getRemovalShipments,
    updateOrderDetails
};

export default RemovalShipmentUtils;